import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled('section')(
  () => css`
    max-width: 1180px;
    margin: 0 auto;
    padding: 80px 15px 0;
    position: relative;
  `
)

export const Wrapper = styled('div')(() => css``)

export const Content = styled('div')(
  () => css`
    position: relative;

    svg {
      position: absolute;
      top: -55px;
      right: -70px;
    }
  `
)

export const Title = styled('h2')(
  () => css`
    font-size: 35px;
    font-family: 'Segoe UI', Arial;
    font-weight: 400;
    color: #78be20;
    display: flex;
    margin-bottom: 20px;

    @media (max-width: 768px) {
      font-size: 28px;
    }

    span {
      font-weight: 800;
      margin-right: 10px;
    }
  `
)

export const InfoContainer = styled('div')(
  () => css`
    p {
      font-size: 18px;
      line-height: 26px;
      max-width: 760px;
      margin-bottom: 20px;
    }
  `
)
